import { t } from 'ttag';
import  classNames from 'classnames';

import { Modal, ModalProps } from '@ui/Modal';
import { Button } from '@ui/Button';

import s from './VerifySafePaymentDisableModal.sss';

type Props = ModalProps & {
  onConfirm: () => void
};

export const VerifySafePaymentDisableModal: React.FC<Props> = ({
  onConfirm,
  onRequestClose,
  className,
  ...props
}) => (
  <Modal
    {...props}
    className={classNames(s.root, className)}
    onRequestClose={onRequestClose}
  >
    <div>
      {t`Rozetka працює лише з Безпечною оплатою. Після вимкнення Безпечної оплати автоматично вимкнеться спосіб доставки Rozetka.`}
    </div>

    <div className={s.buttons}>
      <Button
        className={s.button}
        theme="secondary"
        onClick={onRequestClose}
      >
        {t`Відміна`}
      </Button>
      <Button
        className={s.button}
        onClick={onConfirm}
      >
        {t`Вимкнути`}
      </Button>
    </div>
  </Modal>
);
